import React from 'react';
import { Play } from 'lucide-react';

interface GenerateButtonProps {
  disabled: boolean;
  onClick: () => void;
  taskType?: string;
  isLoading?: boolean;
}

export const GenerateButton: React.FC<GenerateButtonProps> = ({
  disabled,
  onClick,
  taskType,
  isLoading = false,
}) => {
  const getButtonText = () => {
    switch (taskType) {
      case 'DocumentPopulation':
        return 'Generate';
      case 'PHYSICAL_SOAP':
      case 'SoapNote': // Legacy support
        return 'Generate SOAP Note';
      case 'HISTORY_AND_PHYSICAL':
        return 'Generate History & Physical';
      case 'GIRPP':
        return 'Generate GIRPP Note';
      case 'BIRP':
        return 'Generate BIRP Note';
      case 'SIRP':
        return 'Generate SIRP Note';
      case 'DAP':
        return 'Generate DAP Note';
      case 'BEHAVIORAL_SOAP':
        return 'Generate Behavioral SOAP';
      default:
        return 'Generate';
    }
  };

  return (
    <button
      type="button"
      disabled={disabled || isLoading}
      onClick={onClick}
      className="btn btn-primary"
    >
      {isLoading ? (
        <span className="loading loading-spinner loading-sm mr-2"></span>
      ) : (
        <Play className="w-4 h-4" />
      )}
      <span>{getButtonText()}</span>
    </button>
  );
}; 